import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const { batTyveriEllerInnbruddUrl, batKollisjonsskadeUrl } = urler();

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.BatKollisjonsskade,
        tekst: 'Kollisjon',
        undertekst: 'Båten har kollidert med et skjær, gjenstand, brygge eller en annen båt.',
    },
    {
        id: KategoriSvarId.BatenHarSlittFortoyningOgBlittSkadet,
        tekst: 'Slitt seg fra fortøyning',
    },
    {
        id: KategoriSvarId.BatMaskinskader,
        tekst: 'Maskinskader',
    },
    {
        id: KategoriSvarId.BatTyveriEllerInnbrudd,
        tekst: 'Tyveri eller innbrudd',
    },
    {
        id: KategoriSvarId.BatHarSunket,
        tekst: 'Sunket eller delvis sunket',
    },
];

export const Bat = () => {
    const { url } = useConfig().links.meldskadelandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.BatKollisjonsskade) {
            navigate(batKollisjonsskadeUrl);
        } else if (svarId === KategoriSvarId.BatenHarSlittFortoyningOgBlittSkadet) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatHarSlittSegFraFortoyning));
        } else if (svarId === KategoriSvarId.BatMaskinskader) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatMaskinskader));
        } else if (svarId === KategoriSvarId.BatTyveriEllerInnbrudd) {
            navigate(batTyveriEllerInnbruddUrl);
        } else if (svarId === KategoriSvarId.BatHarSunket) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BatHarSunket));
        }
    };

    return (
        <GruppeLandingsside
            title="Båt"
            radioButtonsLabel="Hva har skjedd med båten?"
            onNext={onNext}
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            svgCardType={SvgCardType.BaatSkade}
            kategoriId="bat"
        />
    );
};
